import { useEffect, useState, useContext } from "react";
import { WebhooksValue } from "../contexts/webhooks";
import Dynamic from "./dynamic";
export default function Webhooks({ value, onChange, sources }) {
  const webhooks = useContext(WebhooksValue);
  const [_value, setValue] = useState({ webhook: "", props: {} });
  const [schema, setSchema] = useState(null);

  useEffect(() => {
    if (value) {
      setValue(value);
    }
  }, [value]);

  useEffect(() => {
    const webhook = webhooks.find((x) => x.id === _value.webhook);
    if (webhook) {
      setSchema(webhook.schema);
    }
  }, [_value.webhook]);

  const handleWebhookSelect = (e) => {
    const value = { ..._value };
    value.webhook = e.target.value;
    onChange(value);
  };

  const handlePropsChange = (props) => {
    const value = { ..._value };
    value.props = props;
    onChange(value);
  };
  return (
    <div>
      <select
        value={_value.webhook}
        onChange={handleWebhookSelect}
        className={"dropdown"}
      >
        <option disabled value="">
          select...
        </option>
        {webhooks
          .filter((x) => x.type === "manual")
          .map((hook) => {
            return <option value={hook.id}>{hook.name}</option>;
          })}
      </select>
      {schema && (
        <Props
          onChange={handlePropsChange}
          schema={schema}
          props={_value.props}
          sources={sources}
        />
      )}
    </div>
  );
}

const Props = ({ schema, props, sources, onChange }) => {
  const handleChange = (key, value) => {
    const _props = { ...props };
    _props[key] = value;
    onChange(_props);
  };
  return (
    <div>
      {Object.keys(schema.fields).map((key) => {
        return (
          <div
            key={key}
            style={{ display: "flex", flexDirection: "column", marginTop: 8 }}
          >
            <div>{schema.fields[key].name}</div>
            <Dynamic
              value={props[key]}
              onChange={(v) => handleChange(key, v)}
              sources={sources}
              params={{
                type: schema.fields[key].type,
                list: schema.fields[key].list,
              }}
            />
          </div>
        );
      })}
    </div>
  );
};
